import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  deleteActivity,
  cancelActivity,
  scrolledToActivity,
} from 'shared/portfolio/actions/activities';
import {Store} from 'src/types/store';

import Activity from 'shared/components/form-inputs/activity';
import PortfolioFormFooter from 'src/components/PortfolioFormFooter';
import FormCard from '../form-card';
import ActivitiesFormWrapper, {Activity as ActivityType} from './activities-form-wrapper';

interface Props {
  activity: ActivityType;
}

const ActivityForm = ({activity}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const institution = useSelector(
    (state: Store) =>
      state.institutions[activity.institutionId || state.student.currentInstitution._id]
  );

  useEffect(() => {
    if (activity.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToActivity(activity._id));
      }, 550);
    }
  }, [dispatch, activity._id, activity.scrollTo]);

  let title = 'Add an Extracurricular';
  let referralTitle = 'Invite your friends';

  if (activity.activityType === 'sport') {
    title = `${activity.new ? 'Add' : 'Edit'} Sport`;
    referralTitle = 'Invite your teammates';
  } else if (activity.activityType === 'activity') {
    title = `${activity.new ? 'Add' : 'Edit'} Activity`;
    referralTitle = 'Invite other students';
  }

  if (activity.name) {
    referralTitle += ` from ${activity.name}`;
  }

  referralTitle += ' to join Raise Me (Optional)';

  return (
    <FormCard ref={ref} id={activity._id}>
      <ActivitiesFormWrapper
        initialValues={{
          _id: activity._id,
          name: activity.name,
          description: activity.description,
          activityType: activity.activityType,
          where: activity.where,
          schoolYears: activity.schoolYears,
          participation: activity.participation,
          organization: activity.organization || '',
          leadershipPositions: activity.leadershipPositions,
          institution: {
            parentId: institution.parentId,
            name: institution.name,
            type: institution.type,
          },
          referrals: activity.referrals || [''],
          new: activity.new,
          editing: activity.editing,
          scrollTo: activity.scrollTo,
        }}
      >
        <div className="activity-form">
          <div className="activity-form-header-wrapper">
            <h4 className="activity-form-header add-edit-header porfolio-sections">{title}</h4>
          </div>

          <Activity referralTitle={referralTitle} />

          <PortfolioFormFooter
            _id={activity._id}
            onDelete={() => dispatch(deleteActivity(activity))}
            onCancel={() => dispatch(cancelActivity(activity))}
            formName="portfolio activities activity-form"
          />
        </div>
      </ActivitiesFormWrapper>
    </FormCard>
  );
};

export default ActivityForm;
